module.exports = __webpack_public_path__ + "static/adineuePRO-BoldItalicWeb-bf8b6fdf5df900c61340564888450ab8.woff";